module.exports = __webpack_public_path__ + "static/media/doggos82.65049f1e.webp";